<template>
  <div class="preview-ellipsis">
    <div v-for="(item, index) in displayList" :key="index" class="preview-line">
      {{ formatLine(item) }}
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { formatPreviewLine } from './utils'

const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  maxLines: {
    type: Number,
    default: 4
  }
})

const displayList = computed(() => {
  return (props.list || [])
    .filter(item => item?.sendContent || item?.sendName)
    .slice(0, props.maxLines)
})

const formatLine = item => formatPreviewLine(item)
</script>

<style scoped lang="scss">
.preview-ellipsis {
  padding: 10px 16px;
  border-bottom: 1px solid #efefef;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.04em;
  color: #666666;

  .preview-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
}
</style>
